import { DAY_PASCAL, DAY_TRUNCATED } from '../constants';

const mapTruncatedDayToPascal = (day: DAY_TRUNCATED): DAY_PASCAL => {
  switch (day) {
    case DAY_TRUNCATED.MON:
      return DAY_PASCAL.MONDAY;
    case DAY_TRUNCATED.TUE:
      return DAY_PASCAL.TUESDAY;
    case DAY_TRUNCATED.WED:
      return DAY_PASCAL.WEDNESDAY;
    case DAY_TRUNCATED.THU:
      return DAY_PASCAL.THURSDAY;
    case DAY_TRUNCATED.FRI:
      return DAY_PASCAL.FRIDAY;
    case DAY_TRUNCATED.SAT:
      return DAY_PASCAL.SATURDAY;
    case DAY_TRUNCATED.SUN:
      return DAY_PASCAL.SUNDAY;
    default:
      throw new Error(`Invalid day: ${day}`);
  }
};

export default mapTruncatedDayToPascal;
